import {
  GET_NUTRITION_SUGGESTION,
  GET_NUTRITION_SUGGESTION_SUCCESS,
  GET_NUTRITION_SUGGESTION_ERROR,
  GET_COACHING_MESSAGE,
  GET_COACHING_MESSAGE_SUCCESS,
  GET_COACHING_MESSAGE_ERROR,
  GET_ASSESSMENT_SUMMARY,
  GET_ASSESSMENT_SUMMARY_SUCCESS,
  GET_ASSESSMENT_SUMMARY_ERROR,
} from './constants';

const initialState = {
  nutritionSuggestion: null, // { title, body, source: 'llm'|'rule', cached: bool }
  nutritionSuggestionLoading: false,
  nutritionSuggestionError: null,
  coachingMessage: null, // { title, body, tone, source, cached }
  coachingMessageLoading: false,
  coachingMessageError: null,
  // Single-slot trainer-side: { summary, highlights, source, cached } | null
  // Tracked alongside the clientId it was fetched for so the Assessment
  // tab can detect a stale slot when the trainer navigates to a different
  // client (the saga refetches on clientId change).
  assessmentSummary: null,
  assessmentSummaryClientId: null,
  assessmentSummaryLoading: false,
  assessmentSummaryError: null,
};

export default function ai(state = initialState, action) {
  switch (action.type) {
    case GET_NUTRITION_SUGGESTION:
      return {
        ...state,
        nutritionSuggestionLoading: true,
        nutritionSuggestionError: null,
      };
    case GET_NUTRITION_SUGGESTION_SUCCESS:
      return {
        ...state,
        nutritionSuggestion: action.payload,
        nutritionSuggestionLoading: false,
        nutritionSuggestionError: null,
      };
    case GET_NUTRITION_SUGGESTION_ERROR:
      return {
        ...state,
        nutritionSuggestionLoading: false,
        nutritionSuggestionError: action.err,
      };
    case GET_COACHING_MESSAGE:
      return {
        ...state,
        coachingMessageLoading: true,
        coachingMessageError: null,
      };
    case GET_COACHING_MESSAGE_SUCCESS:
      return {
        ...state,
        coachingMessage: action.payload,
        coachingMessageLoading: false,
        coachingMessageError: null,
      };
    case GET_COACHING_MESSAGE_ERROR:
      return {
        ...state,
        coachingMessageLoading: false,
        coachingMessageError: action.err,
      };
    case GET_ASSESSMENT_SUMMARY:
      return {
        ...state,
        // Clear the previous client's summary immediately so the
        // Assessment tab shows a loading state instead of stale text
        // while the new fetch is in flight.
        assessmentSummary:
          state.assessmentSummaryClientId === action.clientId
            ? state.assessmentSummary
            : null,
        assessmentSummaryClientId: action.clientId,
        assessmentSummaryLoading: true,
        assessmentSummaryError: null,
      };
    case GET_ASSESSMENT_SUMMARY_SUCCESS:
      // Ignore late arrivals for a client we've already moved off — the
      // saga uses takeLatest so this is unlikely, but the guard is cheap.
      if (
        action.clientId &&
        state.assessmentSummaryClientId &&
        action.clientId !== state.assessmentSummaryClientId
      ) {
        return state;
      }
      return {
        ...state,
        assessmentSummary: action.payload,
        assessmentSummaryLoading: false,
        assessmentSummaryError: null,
      };
    case GET_ASSESSMENT_SUMMARY_ERROR:
      if (
        action.clientId &&
        state.assessmentSummaryClientId &&
        action.clientId !== state.assessmentSummaryClientId
      ) {
        return state;
      }
      return {
        ...state,
        assessmentSummaryLoading: false,
        assessmentSummaryError: action.err,
      };
    default:
      return state;
  }
}
